import Calendar from "../components/calendar/Calendar";
import { SubscripcionContextProvider } from "../context/SubscripcionContextProvider";

export default [
  {
    path: "Calendario",
    element: (
      <SubscripcionContextProvider>
        <Calendar />
      </SubscripcionContextProvider>
    ),
  },
];
